/**
 * If $value is missing a unit, automatically appends `px` to the end.
 * @param {string} value
 * @returns {string}
 */
export function fixUnitlessValue(value) {
  if (!value) {
    return value
  }
  const match = value.match(/^(-?[\d.]+)$/)
  if (match !== null) {
    return `${match[1]}px`
  }
  return value
}

/**
 * @param {string} fullValue
 * @returns {{unit: string, value: string}}
 */
export function parseValue(fullValue) {
  let value
  let unit

  const match = fullValue.match(/^(-?[\d.]+)(.*)$/)
  if (match !== null) {
    // Value is something like 30px, 30%, 1.2rem
    value = match[1]
    unit = value === '0' && !unit ? 'px' : match[2]
  } else {
    value = fullValue || ''
    unit = ''
  }

  return { value, unit }
}

/**
 *
 * @param {string} value
 * @param {string} unit
 * @returns {string}
 */
export function combineValueAndUnit(value, unit) {
  if (value === '0' && unit === 'px') {
    return '0'
  }

  return value + (value !== '' && unit ? unit : '')
}
